// src/components/Presidente/PresidenteDetails.jsx
import React, { useEffect, useState } from 'react';
import { obterPresidente } from '../../services/presidenteService';
import { useParams } from 'react-router-dom';

const PresidenteDetails = () => {
    const { id } = useParams();
    const [presidente, setPresidente] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            const response = await obterPresidente(id);
            setPresidente(response.data);
        };
        fetchData();
    }, [id]);

    if (!presidente) return <p>Carregando...</p>;

    return (
        <div>
            <h2>Nome: {presidente.usuario.nome}</h2>
            <p>Email: {presidente.usuario.email}</p>
            <p>Departamento: {presidente.departamento}</p>
            <p>Data de Nomeação: {presidente.data_nomeacao}</p>
        </div>
    );
};

export default PresidenteDetails;